import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class NwSelectorsLanguageSelectComponent extends Component {
  @service siteData;

  get languages() {
    return this.siteData.languages?.map(([id, text]) => ({
      id,
      text,
    }));
  }
}
